module.exports = __webpack_public_path__ + "img/croissant_haev.899ab3dc.jpg";